import { queryAvailability } from './api/query-availability';
import { getLocalDateTimeEndOfDay, getLocalDateTimeStartOfDay } from './date-utils';
export const getAvailabilityDates = ({ httpClient: _httpClient, errorHandler })=>{
    return async ({ serviceId, fromDate, toDate, timeZone })=>{
        const fromLocalDate = getLocalDateTimeStartOfDay(fromDate);
        const toLocalDate = getLocalDateTimeEndOfDay(toDate);
        return (await queryAvailability({
            httpClient: _httpClient,
            errorHandler,
            request: {
                query: {
                    filter: {
                        serviceId: [
                            serviceId
                        ],
                        startDate: fromLocalDate,
                        endDate: toLocalDate,
                        bookable: true
                    }
                },
                timezone: timeZone,
                slotsPerDay: 1,
                allowProxyToAvailability: true
            }
        }))?.availabilityEntries || [];
    };
};

//# sourceMappingURL=get-availability-dates.js.map